// @flow
import { batch } from 'react-redux';
import type { Dispatch } from 'redux';

import {
    createToolbarEvent,
    sendAnalytics
} from '../../analytics';
import { TILE_VIEW_ENABLED, getFeatureFlag } from '../../base/flags';
import { translate } from '../../base/i18n';
import { IconTileView } from '../../base/icons';
import { connect } from '../../base/redux';
import { AbstractButton, type AbstractButtonProps } from '../../base/toolbox/components';
import { setOverflowMenuVisible } from '../../toolbox/actions';
import { setTileView } from '../actions';
import { shouldDisplayTileView } from '../functions';
import logger from '../logger';

// CUSTOM:
import { getActiveSession } from '../../recording/functions';
import { JitsiRecordingConstants } from '../../base/lib-jitsi-meet';
import { getLocalParticipant } from '../../base/participants';
import { socketEmit } from "../../../../socket";
import { getConferenceNameForTitle } from '../../base/conference';
import { FEATURE_CUSTOM_REDUX } from '../../customise/constant';
import { setScreenView } from '../../customise/redux/tool-webjam-v2/actions';
import { CURRENT_ROOM_NAME } from '../../webjam/constant';
// END

/**
 * The type of the React {@code Component} props of {@link TileViewButton}.
 */
type Props = AbstractButtonProps & {

    /**
     * Whether or not tile view layout has been enabled as the user preference.
     */
    _tileViewEnabled: boolean,

    /**
     * Used to dispatch actions from the buttons.
     */
    dispatch: Dispatch<any>
};

/**
 * Component that renders a toolbar button for toggling the tile layout view.
 *
 * @augments AbstractButton
 */
class TileViewButton<P: Props> extends AbstractButton<P, *> {
    accessibilityLabel = 'toolbar.accessibilityLabel.tileView';
    icon = IconTileView;
    label = 'toolbar.enterTileView';
    toggledLabel = 'toolbar.exitTileView';
    tooltip = 'toolbar.tileViewToggle';

    /**
     * Handles clicking / pressing the button.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        // CUSTOM
        // const { _tileViewEnabled, dispatch } = this.props;
        const { _tileViewEnabled, dispatch, handleClick, participants, _roomName, _isLiveStreamRunning, _isRecordingRunning, getLocalParticipant, roomorIpAddress } = this.props;

        // if (handleClick) {
        //     handleClick();
        //     return;
        // }
        // END

        const value = !_tileViewEnabled;

        sendAnalytics(createToolbarEvent(
            'tileview.button',
            {
                'is_enabled': value
            }));

        logger.debug(`Tile view ${value ? 'enable' : 'disable'}`);
        batch(() => {
            dispatch(setTileView(value));
            navigator.product !== 'ReactNative' && dispatch(setOverflowMenuVisible(false));
        });

        // CUSTOM
        console.log(" GHOST TILEVIEW change_streaming 222 ", roomorIpAddress, _isLiveStreamRunning, _isRecordingRunning);
        if ((_isLiveStreamRunning || _isRecordingRunning) && getLocalParticipant.role == 'moderator') {
            // if (getLocalParticipant.role == 'moderator') {
            let obj = {
                roomName: CURRENT_ROOM_NAME,
                tileView: value
            };
            socketEmit("change_streaming_user_view", obj);

            console.log("participants.length 444--- ", participants.length)
            // TO HIGHLIGHT DEFAULT USER FROM TILE TO NO_TILE VIEW FOR THE FIRTS TIME
            // if (!value && participants && participants.length > 1) {
            //     var newobj = participants[participants.length - 1];
            //     console.log('change_streaming newobj 555', newobj);

            //     socketEmit("highlight_streaming_user_thumbnail", {
            //         // roomName: roomorIpAddress,
            //         roomName: CURRENT_ROOM_NAME,
            //         pinId: newobj.id,
            //         pinned: false
            //     });
            // }
        }
        // Setting preferred Screen view and not changing view when new user joining or left the room.
        dispatch(setScreenView(value ? 1 : 2));
        // END
    }

    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._tileViewEnabled;
    }
}

/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code TileViewButton} component.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} ownProps - The properties explicitly passed to the component instance.
 * @returns {Props}
 */
function _mapStateToProps(state, ownProps) {
    const enabled = getFeatureFlag(state, TILE_VIEW_ENABLED, true);
    const { visible = enabled } = ownProps;

    // CUSTOM
    const _roomName = getConferenceNameForTitle(state);
    // END

    return {
        _tileViewEnabled: shouldDisplayTileView(state),
        visible,
        // CUSTOM
        _isLiveStreamRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.STREAM)),
        _isRecordingRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.FILE)),
        getLocalParticipant: getLocalParticipant(state),
        roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
        _roomName: _roomName,
        participants: state['features/base/participants']
        // END
    };
}

export default translate(connect(_mapStateToProps)(TileViewButton));
